import updateOrganizationRoleMutation from "/public/graphQl/mutations/updateOrganizationRole.js";

export const updateOrganizationRole = async ({commit, dispatch, rootGetters,rootState, state}, payload) => {
    const selectedOrganizationId = rootGetters['app/getSelectedOrganizationId'];
    let currenciesData;

    let variables = {
        organizationId: selectedOrganizationId,
        organizationRoleId: state.detailRoleId,
        name: payload.name,
        rules: JSON.stringify(payload.rules),
        comment: payload.comment,
    };

    try {
        if (!rootState.app.isLoading) {
            commit('app/setLoading', true, {root: true});
        }
        currenciesData = await dispatch('app/request', {
            type: 'query',
            gql: updateOrganizationRoleMutation,
            variables,
        }, {root: true});
    } catch (error) {
        return error;
    } finally {
        commit('app/setLoading', false, {root: true});
    }

    if (currenciesData.message) {
        throw currenciesData.message;
    }

    if (currenciesData.errors) {
        throw currenciesData.errors;
    }

    return true;
};
